module.exports = __webpack_public_path__ + "static/media/app_screens_4.13cd21cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app_screens_4.png
// module id = 369
// module chunks = 0